import React, { useState } from 'react';
import Notice from './Notice';
import { useGroup } from '../../contexts/GroupContext';
import { useSpaceAccess } from '../../nucleus/access';
import { useToast } from '../common';
import { rotateGroupKey } from '../../pages/nucleus/PeopleGroupData';

// SOMEONE LEFT AN ENCRYPTED GROUP: the server marks it `needs_rekey` (a removal
// re-keys at once; a member leaving cannot, it holds no right to). Its admins see
// it at the top of This group and Home, with the re-key itself. A rotation
// clears the mark. Members never see it: re-keying is an admin's.

/** The words, for one group. */
export const rekeyLine = (name) => `Someone left ${name || 'this group'}. Re-key it so they can’t read what comes next.`;

/** Should this viewer be told: an admin, of a group marked as needing a re-key. */
export const needsRekey = (group, isAdmin) => !!isAdmin && !!group && group.needs_rekey === true;

/**
 * The notice, or nothing. `group` is the group as the page read it (else the
 * one you are in); `onDone` runs after a re-key (the page reads the group again).
 */
export default function RekeyNotice({ group: given = null, onDone }) {
    const { activeGroup, refreshGroups } = useGroup() || {};
    const access = useSpaceAccess();
    const toast = useToast();
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const group = given || activeGroup;
    if (done || !access.inGroup || !needsRekey(group, access.isAdmin)) return null;
    const run = async () => {
        if (busy) return;
        setBusy(true);
        try {
            const r = await rotateGroupKey(group.id);
            setDone(true);
            toast.success?.(r ? `${group.name || 'The group'} has a fresh key.` : 'Re-keyed.');
            await refreshGroups?.();
            await onDone?.();
        } catch (e) {
            toast.error?.(e?.message || 'Couldn’t re-key it.');
        }
        setBusy(false);
    };
    return <Notice title={rekeyLine(group.name)} action={{ label: busy ? 'Re-keying…' : 'Re-key', run }} />;
}
